import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import PurchaseOrderServices from "../../services/purchaseOrder.service";
import "../../assets/css/po2-design.css";

// Epic 1857 UI-redesign Phase 9: a real, separate Inbox for the retailer, matching the
// prototype's rInbox() exactly - task 1902's own "how does the retailer discover a
// worksheet is waiting on them" requirement, which F3 (8 September) folded into
// MyOrders.js's generic list instead of building as its own screen. Reuses the same
// GetMyOrdersByStatus data MyOrders.js already fetches (no new endpoint), filtered
// client-side to PENDING_RETAILER - the one status that means "action needed from me."
const Inbox = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    PurchaseOrderServices.GetMyOrdersByStatus()
      .then((res) => {
        setLoading(false);
        if (res?.data?.status) setOrders(res.data.responseData || []);
      })
      .catch(() => setLoading(false));
  }, []);

  const inbox = useMemo(() => orders.filter((o) => o.statusCode === "PENDING_RETAILER"), [orders]);

  const fmtDate = (v) => (v ? new Date(v).toLocaleString() : "-");

  return (
    <div className="po2-scope" dir={isRtl ? "rtl" : "ltr"}>
      <div className="po2-phead">
        <div>
          <h1>{t("Inbox")}</h1>
          <div className="po2-desc">{t("Worksheets vendors have sent you")}</div>
        </div>
      </div>

      <Spin spinning={loading}>
        {inbox.length > 0 ? (
          <>
            <div className="po2-insight">
              <b>{t("These are proposals, not commitments")}</b>
              {t("Approve as written, or change quantities and send them back. Prices, discounts and terms are set by the vendor and are not editable.")}
            </div>
            {inbox.map((o) => (
              <div className="po2-panel" key={o.poId}>
                <div className="po2-ph">
                  <h3>PO-{o.poId} — {o.counterpartyCompanyName || t("Unknown vendor")}</h3>
                  <span className="po2-desc">
                    {o.lineCount || 0} {t("lines")} · {o.unitCount || 0} {t("units")} · {t("received")} {fmtDate(o.createdDate)}
                  </span>
                  <div className="po2-right">
                    <b style={{ fontFamily: "var(--po2-mono)", fontSize: "var(--po2-t5)", fontVariantNumeric: "tabular-nums" }}>
                      ${(o.orderTotal ?? 0).toFixed(2)}
                    </b>
                    <button className="po2-btn" onClick={() => navigate(`/orderDetail/${o.poId}`)}>
                      {t("Review")}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="po2-panel">
            <div className="po2-empty">
              <div className="po2-ic">✓</div>
              <p>{t("Nothing waiting on you.")}</p>
            </div>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default Inbox;
